import React, { Component } from "react";
import "./publications.css";

class Publications extends Component {
  render() {
    return (
      <div className="">
        <div className="row no-gutters">
          <div className="project offset-lg-2 col-lg-8 col-sm-12 col-md-12">
            <ul>
              <li className="publications-list m-4">
                <a
                  className="publications-link"
                  href="https://advanced.onlinelibrary.wiley.com/doi/10.1002/advs.202414149"
                >
                  Dahari, A., Docherty, R., Kench, S. and Cooper, S.J.
                  Prediction of microstructural representativity from a single
                  image. Advanced Science (2025). DOI
                  https://doi.org/10.1002/advs.202414149
                </a>
              </li>

              <li className="publications-list m-4">
                <a
                  className="publications-link"
                  href="https://chemrxiv.org/engage/chemrxiv/article-details/68402c711a8f9bdab5a0b7fc"
                >
                  Vamvakeros, A., Papoutsellis, E., Dong, H., Docherty, R.,
                  Beale, A.M, Cooper, S.J and Jacques, S.D.M. nDTomo: A
                  Python-Based Software Suite for X-ray Chemical Imaging and
                  Tomography. chemrXiv preprint (2025). DOI
                  https://doi.org/10.26434/chemrxiv-2025-h5t2x
                </a>
              </li>

              <li className="publications-list m-4">
                <a
                  className="publications-link"
                  href="https://arxiv.org/abs/2502.10871"
                >
                  Gei, L., and Cooper, S.J. Layerwise Recall and the Geometry of
                  Interwoven Knowledge in LLMs, arXiv preprint, (2025). DOI
                  https://doi.org/10.48550/arXiv.2502.10871
                </a>
              </li>

              <li className="publications-list m-4">
                <a
                  className="publications-link"
                  href="https://www.cell.com/matter/fulltext/S2590-2385(24)00446-6"
                >
                  Kench, S., Squires, I., Dahrai, A., Planella, F.B., Roberts,
                  S.A. and Cooper, S.J. Li-ion battery design through
                  microstructural optimization using generative AI. Matter
                  (2024). DOI https://doi.org/10.1016/j.matt.2024.08.014
                </a>
              </li>

              <li className="publications-list m-4">
                <a
                  className="publications-link"
                  href="https://arxiv.org/abs/2410.19836"
                >
                  Docherty, R., Vamvakeros, A. and Cooper, S.J. Upsampling
                  DINOv2 features for unsupervised vision tasks and weakly
                  supervised materials segmentation. NeurIPS AI4Mat Workshop,
                  (2024). DOI https://doi.org/10.48550/arXiv.2410.19836
                </a>
              </li>

              <li className="publications-list m-4">
                <a
                  className="publications-link"
                  href="https://zenodo.org/records/13744639"
                >
                  Kench, S., Jones, C., Cooper, S.J and Squires, I. Polaron: An
                  AI tool for the characterisation and design of advanced
                  materials. Whitepaper (2024). DOI
                  https://doi.org/10.5281/zenodo.13744638
                </a>
              </li>

              <li className="publications-list m-4">
                <a
                  className="publications-link"
                  href="https://www.cell.com/cell-reports-physical-science/fulltext/S2666-3864(24)00428-4?uuid=uuid%3A53ca24d2-afda-404b-b22c-9071fad122b1"
                >
                  Hair, S.W, Cooper, S.J. and Shaffer, M.S.P. Beyond slurry
                  cast: Patterning of a monolithic active material sheet to form
                  free-standing, solvent-free, and low-tortuosity battery
                  electrodes. Cell Reports Physical Science (2024). DOI
                  https://doi.org/10.1016/j.xcrp.2024.102143
                </a>
              </li>

              <li className="publications-list m-4">
                <a
                  className="publications-link"
                  href="https://pubs.rsc.org/en/content/articlelanding/2024/dd/d4dd00074a"
                >
                  Gei, L., Docherty, R. and Cooper, S.J. Materials science in
                  the era of large language models: a perspective. Digital
                  Discovery (2024). DOI https://doi.org/10.1039/D4DD00074A
                </a>
              </li>
              <li className="publications-list m-4">
                <a
                  className="publications-link"
                  href="https://joss.theoj.org/papers/10.21105/joss.06159"
                >
                  Docherty, R., Squires, I., Vamvakeros, A. and Cooper, S.J.
                  SAMBA: A Trainable Segmentation Web-App with Smart Labelling.
                  Journal of Open Source Software, 9(98), 6159,
                  https://doi.org/10.21105/joss.06159
                </a>
              </li>
              <li className="publications-list m-4">
                <a
                  className="publications-link"
                  href="https://iopscience.iop.org/article/10.1149/1945-7111/ad48be"
                >
                  Squires, I., Foster, J.M., Galvis, A., and Cooper, S.J.
                  Investigating the Effect of the Separation of Scales in
                  Reduced Order Battery Modelling: Implications on the Validity
                  of the Newman Model. J. Electrochem. Soc. 171 050536 (2024).
                  https://doi.org/10.1149/1945-7111/ad48be
                </a>
              </li>
              <li className="publications-list m-4">
                <a
                  className="publications-link"
                  href="https://www.sciencedirect.com/science/article/pii/S0013468623015906"
                >
                  Yasmin, L., Atkinson, A., Cooper, S.J and Bertei, A.
                  Identifiability of the mechanisms governing the reaction
                  kinetics of MIEC electrodes in solid oxide cells.
                  Electrochimica Acta, Volume 472, 143418, (2023).
                  https://doi.org/10.1016/j.electacta.2023.143418
                </a>
              </li>
              <li className="publications-list m-4">
                <a
                  className="publications-link"
                  href="https://joss.theoj.org/papers/10.21105/joss.05358"
                >
                  Kench, S., Squires, I. and Cooper, S.J. TauFactor 2: A GPU
                  accelerated python tool for microstructural analysis. Journal
                  of Open Source Software, 8(88), 5358, (2023).
                  https://doi.org/10.21105/joss.05358
                </a>
              </li>
              <li className="publications-list m-4">
                <a
                  className="publications-link"
                  href="https://arxiv.org/abs/2306.05812"
                >
                  Hogg, A.O.T., Jenkins, M., Liu, H., Squires, I., Cooper, S.J.
                  and Picinali L. HRTF upsampling with a generative adversarial
                  network using a gnomonic equiangular projection. arXiv,
                  2306.05812, (2023), https://doi.org/10.48550/arXiv.2306.05812
                </a>
              </li>
              <li className="publications-list m-4">
                <a
                  className="publications-link"
                  href="https://www.nature.com/articles/s41597-022-01744-1"
                >
                  Kench, S., Squires, I., Dahari, A. and Cooper, S.J. MicroLib:
                  A library of 3D microstructures generated from 2D micrographs
                  using SliceGAN. Sci Data 9, 645 (2022).
                  https://doi.org/10.1038/s41597-022-01744-1
                </a>
              </li>
              <li className="publications-list m-4">
                <a
                  className="publications-link"
                  href="https://doi.org/10.1039/D2DD00120A"
                >
                  Squires, I., Dahari, A., Cooper, S. J. and Kench, S. Artefact
                  removal from micrographs with deep learning based inpainting.
                  Digital Discovery (2023). https://doi.org/10.1039/D2DD00120A
                </a>
              </li>
              <li className="publications-list m-4">
                <a
                  className="publications-link"
                  href="https://iopscience.iop.org/article/10.1149/1945-7111/ac7a68"
                >
                  Cooper, S.J., Roberts, S.A., Liu, Z. and Winiarski, B.
                  Kintsugi Imaging of Battery Electrodes: Distinguishing Pores
                  from the Carbon Binder Domain using Pt Deposition. J.
                  Electrochem. Soc. 169 070512 (2022).
                  https://doi.org/10.1149/1945-7111/ac7a68
                </a>
              </li>
              <li className="publications-list m-4">
                <a
                  className="publications-link"
                  href="https://onlinelibrary.wiley.com/doi/full/10.1002/aenm.202202407"
                >
                  Dahari, A., Kench, S., Squires, I. and Cooper, S.J. Fusion of
                  complementary 2D and 3D mesostructural datasets using
                  generative adversarial networks. Adv. Energy Mater, 13,
                  2202407 (2023) https://doi.org/10.1002/aenm.202202407
                </a>
              </li>
              <li className="publications-list m-4">
                <a
                  className="publications-link"
                  href="https://www.nature.com/articles/s42256-021-00322-1"
                >
                  Kench, S. and Cooper, S.J. Generating three-dimensional
                  structures from a two-dimensional slice with generative
                  adversarial network-based dimensionality expansion. Nat Mach
                  Intell 3, 299–305 (2021).
                  https://doi.org/10.1038/s42256-021-00322-1
                </a>
              </li>
              <li className="publications-list m-4">
                <a
                  className="publications-link"
                  href="https://pubs.acs.org/doi/10.1021/acsenergylett.1c00194"
                >
                  A. Mistry, A. A. Franco, S. J. Cooper, S. A. Roberts, and V.
                  Viswanathan, “How Machine Learning Will Revolutionize
                  Electrochemical Sciences,” ACS Energy Lett., vol. 16, pp.
                  1422–1431, Mar. 2021, doi: 10.1021/acsenergylett.1c00194.
                </a>
              </li>
              <li className="publications-list m-4">
                <a
                  className="publications-link"
                  href="https://www.cell.com/joule/pdf/S2542-4351(20)30562-6.pdf"
                >
                  D. P. Finegan, J. Zhu, X. Feng, M. Keyser, W. Li, M. Z.
                  Bazant, S. J. Cooper, M. Ulmefors, W. Li, M. Z. Bazant, and S.
                  J. Cooper, “The application of data-driven methods and
                  physics-based learning for improving battery safety,” Joule,
                  2020.
                </a>
              </li>
              <li className="publications-list m-4">
                <a
                  className="publications-link"
                  href="https://www.nature.com/articles/s41524-020-00386-4"
                >
                  T.-T. Nguyen, A. Demortière, B. Fleutot, B. Delobel, C.
                  Delacourt, and S. J. Cooper, “The electrode tortuosity factor:
                  why the conventional tortuosity factor is not well suited for
                  quantifying transport in porous Li-ion battery electrodes and
                  what to use instead,” npj Comput. Mater., vol. 6, no. 1, p.
                  123, Dec. 2020, doi: 10.1038/s41524-020-00386-4.
                </a>
              </li>
              <li className="publications-list m-4">
                <a
                  className="publications-link"
                  href="https://www.nature.com/articles/s41524-020-0340-7"
                >
                  A. Gayon-Lombardo, L. Mosser, N. P. Brandon, and S. J. Cooper,
                  “Pores for thought: Generative adversarial networks for the
                  stochastic reconstruction of 3D multi-phase electrode
                  microstructures with periodic boundaries,” npj Comput. Mater.,
                  vol. 6, no. 1, p. 82, Feb. 2020, doi:
                  10.1038/s41524-020-0340-7.
                </a>
              </li>
              <li className="publications-list m-4">
                <a
                  className="publications-link"
                  href="https://doi.org/10.1016/j.jpowsour.2019.02.068"
                >
                  B. Song, A. Bertei, X. Wang, S. J. Cooper, E. Ruiz-Trejo, R.
                  Chowdhury, R. Podor, and N. P. Brandon, “Unveiling the
                  mechanisms of solid-state dewetting in Solid Oxide Cells with
                  novel 2D electrodes,” J. Power Sources, vol. 420, pp. 124–133,
                  Apr. 2019, doi: 10.1016/J.JPOWSOUR.2019.02.068.
                </a>
              </li>
              <li className="publications-list m-4">
                X. Liu, O. O. Taiwo, C. Yin, M. Ouyang, R. Chowdhury, B. Wang,
                H. Wang, B. Wu, N. P. Brandon, Q. Wang, and S. J. Cooper,
                “Aligned Ionogel Electrolytes for High-Temperature
                Supercapacitors,” Adv. Sci., vol. 6, no. 5, p. 1801337, Mar.
                2019, doi: 10.1002/advs.201801337.
              </li>
              <li className="publications-list m-4">
                C. Yin, X. Liu, J. Wei, R. Tan, J. Zhou, M. Ouyang, H. Wang, S.
                J. Cooper, B. Wu, C. George, and Q. Wang, “‘All-in-Gel’ design
                for supercapacitors towards solid-state energy devices with
                thermal and mechanical compliance,” J. Mater. Chem. A, vol. 7,
                no. 15, pp. 8826–8831, 2019, doi: 10.1039/c9ta01155b.
              </li>
              <li className="publications-list m-4">
                C. T. G. Smith, C. A. Mills, S. Pani, R. Rhodes, J. J. Bailey,
                S. J. Cooper, T. S. Pathan, V. Stolojan, D. J. L. Brett, P. R.
                Shearing, and S. R. P. Silva, “X-ray micro-computed tomography
                as a non-destructive tool for imaging the uptake of metal
                nanoparticles by graphene-based 3D carbon structures,”
                Nanoscale, vol. 11, no. 31, pp. 14734–14741, 2019, doi:
                10.1039/c9nr03056e.
              </li>
              <li className="publications-list m-4">
                P. Jacquet, B. Song, R. Podor, J. Lautru, E. R. Trejo, S. J.
                Cooper, J. Teisseire, I. Gozhyk, J. Jupille, and R. Lazzari,
                “Direct Observation of Metallic Thin Layers Dewetting By
                HT-ESEM,” Microsc. Microanal., vol. 25, no. S1, pp. 69–70, Feb.
                2019, doi: 10.1017/s1431927618016070.
              </li>
              <li className="publications-list m-4">
                M. Ouyang, A. Bertei, S. J. Cooper, Y. Wu, X. Liu, P. Boldrin,
                M. Kishimoto, B. Wu, and N. P. Brandon, “Design of Fibre Ni/CGO
                Anode and Model Interpretation,” ECS Trans., vol. 91, no. 1, pp.
                1721–1739, Jul. 2019, doi: 10.1149/09101.1721ecst.
              </li>
              <li className="publications-list m-4">
                S. R. Daemi, C. Tan, T. Volkenandt, S. J. Cooper, A.
                Palacios-Padros, J. Cookson, D. J. L. Brett, and P. R. Shearing,
                “Visualizing the Carbon Binder Phase of Battery Electrodes in
                Three Dimensions,” ACS Appl. Energy Mater., vol. 1, no. 8, pp.
                3702–3710, Aug. 2018, doi: 10.1021/acsaem.8b00501.
              </li>
              <li className="publications-list m-4">
                F. L. E. Usseglio-Viretta, A. Colclasure, A. N. Mistry, K. P. Y.
                Claver, F. Pouraghajan, D. P. Finegan, T. M. M. Heenan, D.
                Abraham, P. P. Mukherjee, D. Wheeler, P. Shearing, S. J. Cooper,
                and K. Smith, “Resolving the Discrepancy in Tortuosity Factor
                Estimation for Li-Ion Battery Electrodes through Micro-Macro
                Modeling and Experiment,” J. Electrochem. Soc., vol. 165, no.
                14, pp. A3403–A3426, Nov. 2018, doi: 10.1149/2.0731814jes.
              </li>
              <li className="publications-list m-4">
                X. Liu, M. Naylor Marlow, S. J. Cooper, B. Song, X. Chen, N. P.
                Brandon, and B. Wu, “Flexible all-fiber electrospun
                supercapacitor,” J. Power Sources, vol. 384, pp. 264–269, Apr.
                2018, doi: 10.1016/j.jpowsour.2018.02.081.
              </li>
              <li className="publications-list m-4">
                M. Niania, R. Podor, T. Ben Britton, C. Li, S. J. Cooper, N.
                Svetkov, S. Skinner, and J. Kilner, “In situ study of strontium
                segregation in La 0.6 Sr 0.4 Co 0.2 Fe 0.8 O 3−δ in ambient
                atmospheres using high-temperature environmental scanning
                electron microscopy,” J. Mater. Chem. A, 2018, doi:
                10.1039/C8TA01341A.
              </li>
              <li className="publications-list m-4">
                H. Téllez Lozano, J. Druce, S. J. Cooper, and J. A. Kilner,
                “Double perovskite cathodes for proton-conducting ceramic fuel
                cells: are they triple mixed ionic electronic conductors?,” Sci.
                Technol. Adv. Mater., vol. 18, no. 1, pp. 977–986, 2017, doi:
                10.1080/14686996.2017.1402661.
              </li>
              <li className="publications-list m-4">
                S. J. Cooper and N. P. Brandon, An Introduction to Solid Oxide
                Fuel Cell Materials, Technology and Applications. 2017.
              </li>
              <li className="publications-list m-4">
                S. J. Cooper, A. Bertei, D. P. Finegan, and N. P. Brandon,
                “Simulated impedance of diffusion in porous media,” Electrochim.
                Acta, vol. 251, pp. 681–689, 2017, doi:
                10.1016/j.electacta.2017.07.152.
              </li>
              <li className="publications-list m-4">
                S. J. Cooper, M. Niania, F. Hoffmann, and J. A. Kilner,
                “Back-exchange: a novel approach to quantifying oxygen diffusion
                and surface exchange in ambient atmospheres,” Phys. Chem. Chem.
                Phys., vol. 19, no. 19, pp. 12199–12205, May 2017, doi:
                10.1039/C7CP01317E.
              </li>
              <li className="publications-list m-4">
                S. J. Cooper and N. P. Brandon, Solid Oxide Fuel Cell Lifetime
                and Reliability, 1st ed. London, 2017.
              </li>
              <li className="publications-list m-4">
                S. J. Cooper, A. Bertei, P. R. Shearing, J. A. Kilner, and N. P.
                Brandon, “TauFactor: An open-source application for calculating
                tortuosity factors from tomographic data,” SoftwareX, vol. 5,
                pp. 203–210, 2016, doi: 10.1016/j.softx.2016.09.002.
              </li>
              <li className="publications-list m-4">
                B. Tjaden, S. J. Cooper, D. J. L. Brett, D. Kramer, and P. R.
                Shearing, “On the origin and application of the Bruggeman
                correlation for analysing transport phenomena in electrochemical
                systems,” Curr. Opin. Chem. Eng., vol. 12, pp. 44–51, 2016, doi:
                10.1016/j.coche.2016.02.006.
              </li>
              <li className="publications-list m-4">
                S. J. Cooper, M. Niania, F. Hoffmann, and J. A. Kilner,
                “Quantifying the surface exchange coefficient of cathode
                materials in ambient atmospheres,” Proc. 12th Eur. SOFC SOE
                Forum, vol. 12, no. July, pp. 38–45, 2016.
              </li>
              <li className="publications-list m-4">
                N. Ni, S. J. Cooper, R. Williams, N. Kemen, D. W. McComb, and S.
                J. Skinner, “Degradation of
                (La0.6Sr0.4)0.95(Co0.2Fe0.8)O3-δSolid Oxide Fuel Cell Cathodes
                at the Nanometer Scale and below,” ACS Appl. Mater. Interfaces,
                vol. 8, no. 27, pp. 17360–17370, 2016, doi:
                10.1021/acsami.6b05290.
              </li>
              <li className="publications-list m-4">
                N. Na, C. Samuel, S. Stephen, N. Na, C. Samuel, and S. Stephen,
                “Degradation of (La,Sr)(Co,Fe)O3-δSOFC Cathodes at the Nanometre
                Scale and Below,” in European Microscopy Congress 2016:
                Proceedings, Weinheim, Germany: Wiley-VCH Verlag GmbH & Co.
                KGaA, 2016, pp. 808–809.
              </li>
              <li className="publications-list m-4">
                D. P. Finegan, S. J. Cooper, B. Tjaden, O. O. Taiwo, J. Gelb, G.
                Hinds, D. J. L. Brett, and P. R. Shearing, “Characterising the
                structural properties of polymer separators for lithium-ion
                batteries in 3D using phase contrast X-ray microscopy,” J. Power
                Sources, vol. 333, pp. 184–192, 2016, doi:
                10.1016/j.jpowsour.2016.09.132.
              </li>
              <li className="publications-list m-4">
                D. S. Eastwood, O. O. Taiwo, S. J. Cooper, J. Gelb, F. Tariq, D.
                J. L. Brett, S. J. Harris, N. P. Brandon, P. R. Shearing, P. J.
                Withers, and P. D. Lee, “X-ray imaging of Li batteries and
                electrode materials,” 2015.
              </li>
              <li className="publications-list m-4">
                S. J. Cooper, “Quantifying the Transport Properties of Solid
                Oxide Fuel Cell Electrodes,” Imperial College London, 2015.
              </li>
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

export default Publications;
